export const clients = [
  { name: 'Александр М.', city: 'Москва' },
  { name: 'Дмитрий К.', city: 'Санкт-Петербург' },
  { name: 'Иван П.', city: 'Киев' },
  { name: 'Сергей Н.', city: 'Минск' },
  { name: 'Андрей В.', city: 'Варшава' },
  { name: 'Михаил Т.', city: 'Берлин' },
  { name: 'Николай Р.', city: 'Рига' },
  { name: 'Владимир С.', city: 'Таллин' },
  { name: 'Алексей Ф.', city: 'Вильнюс' },
  { name: 'Евгений Д.', city: 'Бухарест' },
  { name: 'Marco R.', city: 'Рим' },
  { name: 'Luca B.', city: 'Милан' },
  { name: 'Giovanni F.', city: 'Неаполь' },
  { name: 'Stefan M.', city: 'Вена' },
  { name: 'Klaus W.', city: 'Мюнхен' },
  { name: 'Hans G.', city: 'Гамбург' },
  { name: 'Peter S.', city: 'Франкфурт' },
  { name: 'Thomas H.', city: 'Дюссельдорф' },
  { name: 'Jan K.', city: 'Краков' },
  { name: 'Piotr W.', city: 'Гданьск' },
  { name: 'Marek N.', city: 'Вроцлав' },
  { name: 'Georgi P.', city: 'София' },
  { name: 'Ivan D.', city: 'Пловдив' },
  { name: 'Nikolay S.', city: 'Варна' },
  { name: 'Petko M.', city: 'Бургас' },
  { name: 'Hristo V.', city: 'Стара Загора' },
  { name: 'Dimitar K.', city: 'Плевен' },
  { name: 'Vasil T.', city: 'Русе' },
  { name: 'Emil R.', city: 'Велико Търново' },
  { name: 'Борис Л.', city: 'Одесса' },
  { name: 'Тарас Г.', city: 'Харьков' },
  { name: 'Олег Ш.', city: 'Львов' },
  { name: 'Виктор М.', city: 'Днепр' },
  { name: 'Роман К.', city: 'Запорожье' },
  { name: 'Артём Б.', city: 'Екатеринбург' },
  { name: 'Павел Ж.', city: 'Новосибирск' },
  { name: 'Кирилл О.', city: 'Казань' },
  { name: 'Максим У.', city: 'Краснодар' },
  { name: 'Руслан Е.', city: 'Ростов-на-Дону' },
  { name: 'Antoine D.', city: 'Париж' },
  { name: 'Pierre M.', city: 'Лион' },
  { name: 'Jean-Paul B.', city: 'Марсель' },
  { name: 'Carlos G.', city: 'Мадрид' },
  { name: 'Miguel A.', city: 'Барселона' },
  { name: 'Jose L.', city: 'Валенсия' },
  { name: 'Nikos P.', city: 'Афины' },
  { name: 'Kostas M.', city: 'Салоники' },
  { name: 'Yannis T.', city: 'Патры' },
  { name: 'Andrei P.', city: 'Бухарест' },
  { name: 'Mihai C.', city: 'Клуж-Напока' },
  { name: 'Bogdan I.', city: 'Тимишоара' },
  { name: 'Lukas N.', city: 'Прага' },
  { name: 'Tomas V.', city: 'Брно' },
  { name: 'Martin H.', city: 'Братислава' },
  { name: 'Jozef K.', city: 'Кошице' },
  { name: 'Balazs F.', city: 'Будапешт' },
  { name: 'Zoltan M.', city: 'Дебрецен' },
  { name: 'Artur W.', city: 'Познань' },
  { name: 'Tomasz B.', city: 'Лодзь' },
  { name: 'Krzysztof L.', city: 'Катовице' },
  { name: 'Олег Д.', city: 'Алматы' },
  { name: 'Нурлан А.', city: 'Астана' },
  { name: 'Бауыржан С.', city: 'Шымкент' },
  { name: 'Азамат К.', city: 'Бишкек' },
  { name: 'Тимур Р.', city: 'Ташкент' },
  { name: 'Фарид Н.', city: 'Баку' },
  { name: 'Giorgi K.', city: 'Тбилиси' },
  { name: 'Davit M.', city: 'Кутаиси' },
  { name: 'Armen H.', city: 'Ереван' },
  { name: 'Vahagn G.', city: 'Гюмри' },
  { name: 'Mikael S.', city: 'Стокгольм' },
  { name: 'Erik L.', city: 'Гётеборг' },
  { name: 'Lars A.', city: 'Мальмё' },
  { name: 'Bjorn H.', city: 'Осло' },
  { name: 'Ole K.', city: 'Берген' },
  { name: 'Mads P.', city: 'Копенгаген' },
  { name: 'Jens N.', city: 'Орхус' },
  { name: 'Mikko V.', city: 'Хельсинки' },
  { name: 'Jari L.', city: 'Тампере' },
  { name: 'Taavi K.', city: 'Таллин' },
  { name: 'Janis B.', city: 'Рига' },
  { name: 'Tomas J.', city: 'Вильнюс' },
  { name: 'Marius P.', city: 'Каунас' },
  { name: 'Valdas S.', city: 'Клайпеда' },
  { name: 'Risto M.', city: 'Хельсинки' },
  { name: 'Ott S.', city: 'Тарту' },
  { name: 'Raul K.', city: 'Нарва' },
  { name: 'Виталий Г.', city: 'Кишинёв' },
  { name: 'Ион М.', city: 'Тирасполь' },
  { name: 'Драган П.', city: 'Белград' },
  { name: 'Марко Н.', city: 'Нови-Сад' },
  { name: 'Иван Х.', city: 'Загреб' },
  { name: 'Томислав Б.', city: 'Сплит' },
  { name: 'Мирко В.', city: 'Сараево' },
  { name: 'Горан Т.', city: 'Скопье' },
  { name: 'Никола Д.', city: 'Подгорица' },
  { name: 'Enis K.', city: 'Тирана' },
  { name: 'Besnik M.', city: 'Дуррес' },
  { name: 'Christos A.', city: 'Лимасол' },
];

export const profits = [
  { amount: '€720', contract: 'Leopard 2A7+' },
  { amount: '€1 450', contract: 'PzH 2000' },
  { amount: '€2 960', contract: 'Lynx KF41' },
  { amount: '€5 180', contract: 'Skyranger 30' },
  { amount: '€890', contract: 'Boxer MRAV' },
  { amount: '€3 700', contract: 'Gepard SPAAG' },
  { amount: '€1 160', contract: 'Leopard 2A8' },
  { amount: '€7 400', contract: 'Lynx KF41' },
  { amount: '€4 350', contract: 'PzH 2000' },
  { amount: '€2 175', contract: 'Skyranger 30' },
  { amount: '€580', contract: 'Fuchs APC' },
  { amount: '€9 250', contract: 'Leopard 2A7+' },
  { amount: '€1 740', contract: 'Boxer MRAV' },
  { amount: '€6 660', contract: 'Gepard SPAAG' },
  { amount: '€3 330', contract: 'Lynx KF41' },
];